import { v4 as uuidv4 } from 'uuid';

import operatorDefs from '../defaults/operators';

export function getDefaultFilterValue(field) {
  if (field.domain && field.domain.codedValues) {
    return field.domain.codedValues[0];
  }

  return { name: '', code: '' };
}
export function getShortStringOperators()
{
  const operators = operatorDefs['limitedString'];

  return operators || [];
}

export function getEqualsOperator()
{
  const operators = operatorDefs['equals'];

  return operators || [];
}



export function getValidOperators(fieldType) {
  const operators = operatorDefs[getGenericFieldType(fieldType)];

  return operators || [];
} 

export function getGenericFieldType(fieldType) {
  // REST API Field Types
  // strings: 'esriFieldTypeString',
  // dates: 'esriFieldTypeDate',
  // numbers: ['esriFieldTypeOID',
  //           'esriFieldTypeSmallInteger',
  //           'esriFieldTypeInteger',
  //           'esriFieldTypeSingle',
  //           'esriFieldTypeDouble'],

  // JSAPI Field Types
  //small-integer | integer | single | double | long | string | date | oid | geometry | blob | raster | guid | global-id | xml

  switch (fieldType) {
    case null:
      return null;

    case 'esriFieldTypeString':
    case 'esriFieldTypeGUID':
    case 'oid':
    case 'guid':
    case 'global-id':
    case 'string':
      return 'string';

    case 'esriFieldTypeOID':
    case 'esriFieldTypeSmallInteger':
    case 'esriFieldTypeInteger':
    case 'esriFieldTypeSingle':
    case 'esriFieldTypeDouble':
    case 'small-integer':
    case 'integer':
    case 'single':
    case 'double':
    case 'long':
      return 'number';

    case 'esriFieldTypeDate':
    case 'date':
      return 'date';

    case 'epoch':
      return 'epoch';

    default:
      return 'string';
  }
}

export function generateId() {
  return uuidv4();
}

export function checkFieldTypeWarning(sets, esriFieldType, errorMessage) {
  if(!sets) {
    return '';
  }
  let exprSets = Object.values(sets)
  if(!exprSets.length) {
    return '';
  }
  // using a regular for loop here so we can return early if we find a match
  for (let i = 0; i < exprSets.length; i++) {
    const expressions = exprSets[i]?.expressions ? Object.values(exprSets[i]?.expressions) : [];
    if (!expressions.length) {
      return '';
    }
    if (expressions.find(exp => exp?.field?.type === esriFieldType)) {
      return errorMessage;
    }
  }

  return '';
}

